import { GrowthPerformance } from "./applications/analytics/executive/GrowthPerformance/GrowthPerformance";
import { ComparativeSales } from "./applications/analytics/executive/ComparativeSales/ComparativeSales";
import { ComparativeSalesPerformance } from "./applications/analytics/executive/ComparativeSalesPerformance/ComparativeSalesPerformance";
import { PerformanceByProductGroup } from "./applications/analytics/executive/PerformanceByProductGroup/PerformanceByProductGroup";
import { CustomerSales } from "./applications/analytics/executive/CustomerSales/CustomerSales";
import { CustomerGroupProduct } from "./applications/analytics/executive/CustomerGroupProduct/CustomerGroupProduct";

import { DistrictComparativeSalesPerf } from "./applications/analytics/district/ComparativeSalesPerformance";
import { DistrictPerformanceByProductGroup } from "./applications/analytics/district/PerformanceByProductGroup";
import { DistrictComparativeSales } from "./applications/analytics/district/ComparativeSales";
import { DistrictGrowthPerformance } from "./applications/analytics/district/GrowthPerformance";
import { DistrictCustomerSales } from "./applications/analytics/district/CustomerSales";
import { DistrictCustomerGroupProduct } from "./applications/analytics/district/CustomerGroupProduct";

import { AgentComparativeSalesPerf } from "./applications/analytics/agent/ComparativeSalesPerformance";
import { AgentPerformanceByProductGroup } from "./applications/analytics/agent/PerformanceByProductGroup";
import { AgentComparativeSales } from "./applications/analytics/agent/ComparativeSales";
import { AgentGrowthPerformance } from "./applications/analytics/agent/GrowthPerformance";
import { AgentCustomerSales } from "./applications/analytics/agent/CustomerSales";
import { AgentCustomerGroupProduct } from "./applications/analytics/agent/CustomerGroupProduct";

import { RegionComparativeSalesPerf } from "./applications/analytics/region/ComparativeSalesPerformance";
import { RegionPerformanceByProductGroup } from "./applications/analytics/region/PerformanceByProductGroup";
import { RegionComparativeSales } from "./applications/analytics/region/ComparativeSales";
import { RegionGrowthPerformance } from "./applications/analytics/region/GrowthPerformance";
import { RegionCustomerSales } from "./applications/analytics/region/CustomerSales";
import { RegionalCustomerGroupProduct } from "./applications/analytics/region/CustomerGroupProduct";

import { DistributorComparativeSalesPerf } from "./applications/analytics/distributor/ComparativeSalesPerformance";

import { CustomerComparativeSalesPerf } from "./applications/analytics/customer/ComparativeSalesPerformance";

import { ItemsComparativeSalesPerf } from "./applications/analytics/item/ComparativeSalesPerformance";

import { ProductGroupComparativeSalesPerf } from "./applications/analytics/p-group/ComparativeSalesPerformance";

import { OPMIColorScheme } from "../themes/theme-opmi";

import { ColorSchemeDefault } from "../themes/theme-default";

import { ApplicationBrand, MenuItems, ApplicationItems } from "../client-configuration";

const dataManager = MenuItems;

const brand = ApplicationBrand;

const application = ApplicationItems;

const ColorScheme = ColorSchemeDefault;

const comparativeSalesPerf = ComparativeSalesPerformance;

const performanceByProductGroup = PerformanceByProductGroup;

const comparativeSales = ComparativeSales;

const growthPerformance = GrowthPerformance;

const customerSales = CustomerSales;

const comparativeProductSales = CustomerGroupProduct;

const districtComparativeSalesPerf = DistrictComparativeSalesPerf;

const districtPerformanceByProductGroup = DistrictPerformanceByProductGroup;

const districtComparativeSales = DistrictComparativeSales;

const districtGrowthPerformance = DistrictGrowthPerformance;

const districtCustomerSales = DistrictCustomerSales;

const districtComparativeProductSales = DistrictCustomerGroupProduct;

const territoryComparativeSalesPerf = AgentComparativeSalesPerf;

const territoryPerformanceByProductGroup = AgentPerformanceByProductGroup;

const territoryComparativeSales = AgentComparativeSales;

const territoryGrowthPerformance = AgentGrowthPerformance;

const territoryCustomerSales = AgentCustomerSales;

const territoryComparativeProductSales = AgentCustomerGroupProduct;

const regionComparativeSalesPerf = RegionComparativeSalesPerf;

const regionPerformanceByProductGroup = RegionPerformanceByProductGroup;

const regionComparativeSales = RegionComparativeSales;

const regionGrowthPerformance = RegionGrowthPerformance;

const regionCustomerSales = RegionCustomerSales;

const regionalComparativeProductSales = RegionalCustomerGroupProduct;

const distributorComparativeSalesPerf = DistributorComparativeSalesPerf;

const customerComparativeSalesPerf = CustomerComparativeSalesPerf;

const itemsComparativeSalesPerf = ItemsComparativeSalesPerf;

const productGroupComparativeSalesPerf = ProductGroupComparativeSalesPerf;

const exportApplication = {
  "applications": [
    {
      "id": 1,
      "name": "Comparative Sales Performance"
    },
    {
      "id": 3,
      "name": "Performance by Product Group"
    },
    {
      "id": 4,
      "name": "Comparative Sales"
    },
    {
      "id": 7,
      "name": "Customer Group Product"
    },
    {
      "id": 5,
      "name": "Growth Performance"
    },
    {
      "id": 6,
      "name": "Customer Sales"
    }
  ]
}

const exportApplicationCustomer = {
  "applications": [
    {
      "id": 1,
      "name": "Comparative Sales Performance"
    }
  ]
}

const nullData = {
  "sections": [

  ],
  "palettes": [

  ],
  "themes": [

  ]
}

function getDataByEndPoint(title) {
  return dataManager[title] || null;
}

function getData(type, role) {
  let dataMap = null;

  if (role === '5') {
    dataMap = {
      'brand': brand,
      'application': application,
      '1': comparativeSalesPerf,
      '3': performanceByProductGroup,
      '4': comparativeSales,
      '5': growthPerformance,
      '6': customerSales,
      '7': comparativeProductSales,
      'applicationdashboard': exportApplication,
      'colorScheme': ColorScheme,
    }; //national
  } else if (role === '2') {
    dataMap = {
      'brand': brand,
      'application': application,
      '1': districtComparativeSalesPerf,
      '3': districtPerformanceByProductGroup,
      '4': districtComparativeSales,
      '5': districtGrowthPerformance,
      '6': districtCustomerSales,
      '7': districtComparativeProductSales,
      'applicationdashboard': exportApplication,
      'colorScheme': ColorScheme
    }; //district
  } else if (role === '1') {
    dataMap = {
      'brand': brand,
      'application': application,
      '1': territoryComparativeSalesPerf,
      '3': territoryPerformanceByProductGroup,
      '4': territoryComparativeSales,
      '5': territoryGrowthPerformance,
      '6': territoryCustomerSales,
      '7': territoryComparativeProductSales,
      'applicationdashboard': exportApplication,
      'colorScheme': ColorScheme
    }; // agent
  } else if (role === '4') {
    dataMap = {
      'brand': brand,
      'application': application,
      '1': regionComparativeSalesPerf,
      '3': regionPerformanceByProductGroup,
      '4': regionComparativeSales,
      '5': regionGrowthPerformance,
      '6': regionCustomerSales,
      '7': regionalComparativeProductSales,
      'applicationdashboard': exportApplication,
      'colorScheme': ColorScheme
    }; //regional
  } else if (role === '3') {
    dataMap = {
      'brand': brand,
      'application': application,
      '1': distributorComparativeSalesPerf,
      '3': nullData,
      '4': nullData,
      '5': nullData,
      '6': nullData,
      '7': nullData,
      'applicationdashboard': exportApplicationCustomer,
      'colorScheme': ColorScheme
    }; // disrtributor
  } else if (role === '8') {
    dataMap = {
      'brand': brand,
      'application': application,
      '1': customerComparativeSalesPerf,
      '3': nullData,
      '4': nullData,
      '5': nullData,
      '6': nullData,
      '7': nullData,
      'applicationdashboard': exportApplicationCustomer,
      'colorScheme': ColorScheme
    }; //customer
  } else if (role === '9') {
    dataMap = {
      'brand': brand,
      'application': application,
      '1': productGroupComparativeSalesPerf,
      'applicationdashboard': exportApplicationCustomer,
      'colorScheme': ColorScheme
    }; //items
  } else if (role === '10') {
    dataMap = {
      'brand': brand,
      'application': application,
      '1': itemsComparativeSalesPerf,
      'applicationdashboard': exportApplicationCustomer,
      'colorScheme': ColorScheme
    }; //items
  } else {
    dataMap = {
      'brand': brand,
      'application': application,
      '1': nullData,
      '3': nullData,
      '4': nullData,
      '5': nullData,
      '6': nullData,
      'applicationdashboard': exportApplicationCustomer,
      'colorScheme': ColorScheme
    }; //customer
  }


  return dataMap[type] || nullData;
}

export { getDataByEndPoint, getData };